// extracted by mini-css-extract-plugin
export default {"tag":"DetailTags_tag__i1uRZ","tag--dark":"DetailTags_tag--dark__nvytl"};